<template>
	<div class="context-tasks" :class="componentClass" @click.stop.prevent="onMouseDownBackground">

		<!-- процесс: строка ввода первого шага сверху (в пустом процессе - единственная строка ввода) -->
		<new-task-input v-if="withProcessInputs"
						row
						prepend
						class="context-tasks__new-task-row"
						placeholder="первый шаг..."
						:context-id="parent.id"
						:parent="parent"
						:group-id="groupOfContext?.id"
						:index="sortedTasks?.length ? undefined : 1"
						:level="level"
						:readonly="readonly"
						@click.native.stop.prevent=""/>

		<template v-if="sortedTasks?.length">

			<component :is="isVirtualized ? 'div' : 'transition-group'"
					   v-bind="isVirtualized ? {} : {name: 'list', tag: 'div'}">

				<div v-if="isVirtualized" key="__top-spacer" class="context-tasks__spacer"
					 :style="{height: topSpacerHeight+'px'}"></div>

				<div v-for="(item, index) of renderedTasks" class="context-tasks__item" :key="keyFor(item)+'_item'"
					 ref="rowEl" :data-row-id="item.id">

					<template v-if="isHistoryMode && item._subtitle">
						<div class="context-tasks__subtitle"><span>{{ item._subtitle }}</span></div>
					</template>

					<div v-if="withDND" class="context-tasks__droppable" :key="'dummy-droppable-before-'+keyFor(item)">
						<!--					<div v-if="item.id==='tpjHXazFRJqIsDOT9s74WyFl'" class="__debug"></div>-->
						<draggable :id="'dummy-droppable-before-'+item.id"
								   :item="item.id"
								   :draggable="false"
								   :droppable="withDND && goalDropAllowed"
								   :accepts-zones="['tasks', 'goal']"
								   :rejects-ids="rejectIdsFor(item, index)"
								   :preference="1"
								   zone="tasks-pos"
								   class="context-tasks__droppable-zone"
								   :drop-processor="onDropOverPos"/>
					</div>
					<context-task :key="keyFor(item)"
								  :item="item"
								  :siblings="allItems || items"
								  :parent="parent"
								  :index="absoluteIndex(index)"
								  :level="level"
								  :total="sortedTasks.length + (goalTask ? 1 : 0)"
								  :draggable="withDND"
								  :with-tree="withTree"
								  :with-group-name="withGroupName"
								  :with-topic-name="withTopicName"
								  :with-new-task="withNewTask"
								  :with-new-folder="withNewFolder"
								  :with-track="withTrack"
								  :track-link-prev="!!doneAheadFlags[absoluteIndex(index) - 1]"
								  :track-link-next="!!doneAheadFlags[absoluteIndex(index) + 1]"
								  :compact="compact"
								  :readonly="readonly"
								  :without-context-filter="withoutContextFilter"
								  :excludedItems="excludedItems"
								  :open-ids="openIds"
								  :selected-ids="selectedTaskIdSet"
								  @click.native.stop.prevent=""
								  @drag-start="onDragStart"
								  @drag-end="onDragEnd"
								  @select="onSelect"
								  @select-ctrl="onSelectWithCtrl"
								  @select-shift="onSelectWithShift"/>
				</div>

				<div v-if="isVirtualized" key="__bottom-spacer" class="context-tasks__spacer"
					 :style="{height: bottomSpacerHeight+'px'}"></div>

			</component>
		</template>

		<div v-if="!sortedTasks?.length && !canToggleSteps"
			 class="py-3 --empty __empty" :style="emptyStyle">{{ emptyStub }}
		</div>
		<div v-if="withDND" class="context-tasks__droppable">
			<draggable :id="'dummy-droppable-last-'+parent?.id"
					   item="last"
					   :draggable="false"
					   :droppable="withDND && goalDropAllowedAtEnd"
					   :accepts-zones="['tasks', 'goal']"
					   :rejects-ids="rejectIdsFor(items?.length?items[items.length-1]:null, null)"
					   :preference="1"
					   zone="tasks-last"
					   class="context-tasks__droppable-zone"
					   :drop-processor="onDropOverPos"/>
		</div>

<!--		<div v-if="canToggleSteps" class="context-tasks__steps-toggle">

			&lt;!&ndash;			<div class="context-tasks__steps-current">
							<v-icon small>mdi-ray-start-arrow</v-icon>
							<div class="task__subtasks-current-title">
								<div v-if="currentStepTask">
									<div class="caption grey&#45;&#45;text">Сейчас выполняется</div>
									<span>{{ currentStepTask.title }}</span>
								</div>
								<template v-else-if="totalStepTasks">Все шаги завершены</template>
								<template v-else>Добавьте первый шаг процесса</template>
							</div>
							<assignee :item="currentStepTask" small/>
						</div>&ndash;&gt;

			<v-btn text small block tile @click="stepsExpanded = !stepsExpanded">
				<v-icon small left>{{ stepsExpanded ? "mdi-chevron-up" : "mdi-dots-horizontal" }}</v-icon>
				{{ stepsExpanded ? "Скрыть остальные шаги" : "Показать все шаги (" + sortedTasks.length + ")" }}
			</v-btn>
		</div>-->

		<new-task-input v-if="withBottomNewTask"
						row
						class="context-tasks__new-task-row"
						:placeholder="parent?.isProcess ? 'добавить шаг...' : undefined"
						:context-id="parent?.id || context.item?.id"
						:parent="parent || context.item"
						:group-id="groupOfContext?.id"
						:index="(sortedTasks?.length || 0) + 1"
						:level="level"
						:readonly="readonly"
						:with-goal-track="!!goalTask"
						@click.native.stop.prevent=""/>

		<!-- цель процесса: родитель, продублированный последней строкой списка (не droppable, не выбирается) -->
		<template v-if="goalTask">
			<context-task :key="'goal:'+goalTask.id"
						  goal
						  :item="goalTask"
						  :siblings="[]"
						  :parent="parent"
						  :index="sortedTasks.length + (withBottomNewTask ? 1 : 0)"
						  :total="sortedTasks.length + 1"
						  :level="level"
						  :draggable="withDND"
						  :with-tree="false"
						  :with-track="withTrack"
						  :compact="compact"
						  :readonly="readonly"
						  @click.native.stop.prevent=""
						  @drag-start="onGoalDragStart"
						  @drag-end="onGoalDragEnd"/>
			<!-- сброс "после цели": шаг этого процесса становится новой целью (swap), остальные задачи - в конец списка шагов -->
			<div v-if="withDND" class="context-tasks__droppable">
				<draggable :id="'dummy-droppable-after-goal-'+parent?.id"
						   item="after-goal"
						   :draggable="false"
						   :droppable="withDND && goalDropAllowedAtEnd"
						   :accepts-zones="['tasks', 'goal']"
						   :rejects-ids="rejectIdsFor(null, null)"
						   :preference="1"
						   zone="tasks-last"
						   class="context-tasks__droppable-zone"
						   :drop-processor="onDropOverPos"/>
			</div>
		</template>

		<!--		<div v-if="withNewTask" class="context-tasks__new-task">
					<v-text-field v-model="newInlineTask"
								  prepend-icon="mdi-flare"
								  maxlength="256"
								  clearable
								  placeholder="Новая задача" @keyup.enter="onNewInlineTask"/>
				</div>-->

		<!--		<v-overlay :absolute="true"
						   :value="hasActorOfGroupTaskSort">
					<div v-if="actorOfGroupTaskSort" class="d-flex flex-column align-center justify-center text-center">
						<v-avatar small size="48">
							<v-img v-if="actorOfGroupTaskSort.avatar" :src="actorOfGroupTaskSort.avatar?.srcThumb"
								   :lazy-src="actorOfGroupTaskSort.avatar?.srcLazy"/>
							<v-icon v-else small dark class="grey lighten-2">mdi-account</v-icon>
						</v-avatar>
						<div class="mt-2">{{ actorOfGroupTaskSortNick }}</div>
						<div class="caption">передвигает<br/>задачи</div>

					</div>
				</v-overlay>-->
	</div>
</template>

<script>
import ContextTask from "@/components/context/context-task";
//import draggable from '@/components/elements/draggable';
import draggable from '@/components/elements/draggable2';
import vp from "@/mixins/vp";
import {md5} from "@/utils/string";
import {swapProcessGoal} from "@/utils/taskCommands";
import Config from "@/config";
import Vue from "vue";
import base from "@/mixins/base";
import {nick} from "@/utils/user";
import {contextIdChainFor, isTaskDone, MODES, parseContextIdChain, SORT_TYPES, sortByPrio, sortTypes, TABS} from "@/utils/task";
import {obtainRootContext} from "@/utils/context";
import {PRESETS} from "@/utils/pick";
import {intersection, onlyUnique} from "@/utils/utils";
import onEscape from "@/mixins/on-escape";
import Assignee from "@/components/elements/assignee";
import {posAreSiblings, posCanHaveChildren, posLevel, posParent} from "@/utils/pos";
import {mysql2DDMMYYYY} from "@/utils/date";
import storage from "@/utils/storage";
import NewTaskInput from "@/components/elements/new-task-input";

export default {
	name: "context-tasks",
	components: {
		NewTaskInput,
		Assignee,
		ContextTask,
		draggable,
	},
	mixins: [vp, base, onEscape],
	props: {
		items: {},
		level: {
			type: Number,
			default: 0,
		},
		withGroupName: {
			type: Boolean,
			default: false
		},
		withTopicName: {
			type: Boolean,
			default: false
		},
		withNewTask: {
			type: Boolean,
			default: false
		},
		withNewFolder: {
			type: Boolean,
			default: false
		},
		withTrack: {
			type: Boolean,
			default: false
		},
		readonly: {
			type: Boolean,
			default: false
		},
		compact: {
			type: Boolean,
			default: false
		},
		parent: {
			type: Object,
			default: null
		},
		forcedListMode: {
			type: Object,
			default: null
		},
		/**
		 * Forces tree-browsing mode (expand/collapse chevrons + inline children) regardless of the
		 * app's current page context/mode - used by dialog-task-move.vue which browses a context
		 * unrelated to whatever the user currently has open on the main page.
		 */
		forceTree: {
			type: Boolean,
			default: false
		},
		/**
		 * Skips the page-level context filter (e.g. Search preset filters) - used by
		 * dialog-task-move.vue which must always show the full unfiltered task list of the
		 * browsed destination context.
		 */
		withoutContextFilter: {
			type: Boolean,
			default: false
		},
		excludedItems: {},
		/**
		 * Полный (нефильтрованный) список задач этого уровня - если родитель уже отфильтровал items
		 * (см. context-content.vue). По умолчанию используется items.
		 */
		allItems: {
			type: Array,
			default: null
		},
		/**
		 * Если задан массив - все поддеревья закрыты, кроме перечисленных id (auth || id), а сохранённое
		 * в localStorage состояние открытых контекстов игнорируется и не перезаписывается.
		 * Используется в dialog-task-move.vue.
		 */
		openIds: {
			type: Array,
			default: null
		},
		/**
		 * Разрешает windowed-рендеринг (виртуализацию) этого списка при превышении
		 * Config.CONTEXT_VIRTUALIZE_THRESHOLD - включается только для корневого списка
		 * (см. context-content.vue), т.к. только он сам является scroll-контейнером.
		 */
		virtualizable: {
			type: Boolean,
			default: false
		}
	},
	data: () => ({
		newInlineTask: null,

		/**
		 * TODO move this to state? clear this on uiClearBeforeRouting?
		 */
		//lastSelectedTask: null,

		// компактный режим для родителя-процесса: показывать только текущий шаг.
		// не персистится - всегда сбрасывается в компактный вид при пересоздании компонента
		stepsExpanded: false,

		/**
		 * Префикс ключей строк вместо parent.id: после swap цели родитель списка меняется (новый процесс),
		 * но строки шагов те же - сохраняем прежний префикс, чтобы transition-group не пересоздавал весь список.
		 * Сбрасывается, когда родитель меняется по другой причине (см. watch "parent.id").
		 */
		keyScope: null,
		/** {from, to} - ожидаемая смена родителя при swap: from - префикс ключей, to - id нового процесса */
		swapKeyScope: null,

		// windowed-рендеринг: позиция и высота scroll-контейнера (this.$el)
		scrollTop: 0,
		clientHeight: 0,
		// оценка/измеренная высота строки по id задачи - обычный объект, а не Map,
		// т.к. Vue 2 не отслеживает реактивность содержимого Map/Set
		rowHeights: {},
	}),
	computed: {
		listMode() {
			if (this.forceTree) {
				return {
					mode: MODES.TREE,
				};
			}
			if (this.forcedListMode) {
				return this.forcedListMode;
			}
			if (this.context.mode === MODES.HISTORY) {
				return {
					mode: MODES.HISTORY,
					prop: "userActivityAt",
					prop2: "updatedAt",
				};
			}
			if (this.context.mode === MODES.TREE) {
				return {
					mode: MODES.TREE,
				};
			}

			return {
				mode: MODES.LIST,
				prop: null,
			};
		},
		/** Отсортированные шаги так, как они лежат на backend (без оптимистичного swap цели) */
		actualSortedTasks() {
			if (this.isHistoryMode) return this.limitedItems;
			return this.sortedContextTasks(this.limitedItems);
		},
		/** Идёт swap цели именно этого процесса (backend ещё не ответил) */
		pendingGoalSwap() {
			const pending = this.ui.pendingGoalSwap;
			return pending && this.parent?.id === pending.processId ? pending : null;
		},
		/** Последний назначаемый шаг - он станет новой целью при swap (как на backend: swapProcessGoal.ts) */
		pendingGoalStep() {
			if (!this.pendingGoalSwap) return null;
			// явно выбранный шаг (сброс на "после цели") - иначе последний назначаемый
			if (this.pendingGoalSwap.stepId) {
				return (this.actualSortedTasks || []).find(el => el.id === this.pendingGoalSwap.stepId) || null;
			}
			return [...(this.actualSortedTasks || [])].reverse()
				.find(el => el.isActive && !this.isTaskComment(el) && !el.isNote && !el.isTemplate) || null;
		},
		sortedTasks() {
			if (!this.pendingGoalStep) return this.actualSortedTasks;
			// бывшая цель встаёт среди шагов (копия без детей - иначе строка раскрылась бы внутри самой себя),
			// а новая цель выпадает из шагов - она показывается строкой цели
			const oldGoal = {
				...this.parent,
				index: this.pendingGoalSwap.index,
				isProcess: false,
				isFolder: false,
				children: [],
				countChildren: 0,
				countActiveChildren: 0,
				_pendingSwap: true,
			};
			const steps = this.actualSortedTasks.filter(el => el !== this.pendingGoalStep);
			return this.sortedContextTasks([...steps, oldGoal]);
		},
		/**
		 * Цель процесса - родительская задача, дублируемая последней строкой списка его шагов.
		 * Не входит в sortedTasks, поэтому индексы при перетаскивании не затрагивает.
		 */
		/**
		 * Нижняя строка ввода новой задачи (в процессе - "добавить шаг...") выводится и занимает номер перед целью.
		 * Её нет, например, в дереве пользователя (там нет new-task) - тогда цель нумеруется сразу за последним шагом.
		 */
		withBottomNewTask() {
			return !!this.canHaveChildren && !!this.hasFullAccessToContext && !(this.parent?.isProcess && !this.sortedTasks?.length);
		},
		/** Верхняя строка ввода первого шага - только в процессе, где можно добавлять задачи */
		withProcessInputs() {
			return !!this.parent?.isProcess && !this.isHistoryMode && this.canHaveChildren && this.hasFullAccessToContext;
		},
		/**
		 * Для каждой строки sortedTasks: шаг процесса выполнен заранее (выполнен, но стоит после текущего шага).
		 * Нужен, чтобы соединить зелёной линией трека соседние такие шаги.
		 */
		doneAheadFlags() {
			const first = this.parent?.firstAssignableChild;
			if (!this.parent?.isProcess || !first) return [];
			return (this.sortedTasks || []).map(el => isTaskDone(el) && (first.childId || first.taskId) !== el.id && first.index < el.index);
		},
		/**
		 * Во время перетаскивания цели процесса drop-зоны есть только в списке шагов этого процесса (swap)
		 * и в родительском списке, где лежит сам процесс (обычный перенос). Остальные списки её не принимают.
		 */
		goalDropAllowed() {
			const goal = this.ui.draggedGoal;
			if (!goal) return true;
			return this.parent?.id === goal.id || this.parent?.id === goal.contextId;
		},
		/**
		 * Нижние drop-зоны (в конец списка шагов и после цели) для самой цели этого процесса закрыты:
		 * она и так последняя. В родительском списке процесса цель в конец бросить можно.
		 */
		goalDropAllowedAtEnd() {
			if (!this.goalDropAllowed) return false;
			const goal = this.ui.draggedGoal;
			return !(goal && this.parent?.id === goal.id);
		},
		goalTask() {
			if (this.isHistoryMode || !this.parent?.isProcess || !this.sortedTasks?.length) return null;
			// пока идёт swap, целью показывается последний назначаемый шаг
			return this.pendingGoalStep || this.parent;
		},
		currentStepTask() {
			if (!this.parent?.isProcess) return null;
			return this.sortedTasks?.find(el => el.id === (this.parent.firstAssignableChild?.childId || this.parent.firstAssignableChild?.taskId)) || null;
		},
		totalStepTasks() {
			// important to use actual DB values from parent.* props as this.items is not always the full list (filtered with context filter)
			return (this.parent.countAssignableChildren || 0) + (this.parent.countDoneChildren || 0);
		},
		renderedTasks() {
			/*if (this.parent?.isProcess && !this.stepsExpanded) {
				return this.currentStepTask ? [this.currentStepTask] : [];
			}*/
			if (!this.isVirtualized) return this.sortedTasks;
			return this.sortedTasks.slice(this.renderRange.start, this.renderRange.end);
		},
		/**
		 * Виртуализация (windowed-рендеринг) включается только для корневого списка
		 * (virtualizable=true, см. context-content.vue), выше порога Config.CONTEXT_VIRTUALIZE_THRESHOLD,
		 * и только когда список не в режиме drag&drop - иначе draggable2.vue не найдёт вне-окна
		 * элементы, т.к. его findDroppable() работает по фактически смонтированным компонентам.
		 */
		isVirtualized() {
			return this.virtualizable
				&& (this.sortedTasks?.length || 0) > Config.CONTEXT_VIRTUALIZE_THRESHOLD
				&& !this.withDND;
		},
		/** Накопленные оценочные top-офсеты каждой задачи в sortedTasks + суммарная высота списка. */
		virtualRowOffsets() {
			if (!this.isVirtualized) return null;
			const offsets = [];
			let acc = 0;
			for (const item of this.sortedTasks) {
				offsets.push(acc);
				acc += this.rowHeights[item.id] || Config.CONTEXT_VIRTUALIZE_ROW_HEIGHT;
			}
			return {offsets, total: acc};
		},
		/** Диапазон [start, end) индексов sortedTasks, которые нужно реально отрендерить. */
		renderRange() {
			const total = this.sortedTasks?.length || 0;
			if (!this.isVirtualized || !total) return {start: 0, end: total};

			if (!this.clientHeight) {
				// контейнер ещё не измерен ResizeObserver'ом - рендерим разумное число строк по умолчанию
				return {start: 0, end: Math.min(total, Config.CONTEXT_VIRTUALIZE_INITIAL_ROWS)};
			}

			const {offsets} = this.virtualRowOffsets;
			const overscan = this.clientHeight * 1.5;
			const rangeTop = Math.max(0, this.scrollTop - overscan);
			const rangeBottom = this.scrollTop + this.clientHeight + overscan;

			let start = 0;
			while (start < offsets.length - 1 && offsets[start + 1] <= rangeTop) start++;
			let end = start;
			while (end < offsets.length && offsets[end] < rangeBottom) end++;

			return {start, end};
		},
		topSpacerHeight() {
			if (!this.isVirtualized) return 0;
			return this.virtualRowOffsets.offsets[this.renderRange.start] || 0;
		},
		bottomSpacerHeight() {
			if (!this.isVirtualized) return 0;
			const {offsets, total} = this.virtualRowOffsets;
			const end = this.renderRange.end;
			const endOffset = end < offsets.length ? offsets[end] : total;
			return Math.max(0, total - endOffset);
		},
		canToggleSteps() {
			return !!this.parent?.isProcess && this.sortedTasks?.length > (this.currentStepTask ? 1 : 0);
		},
		limitedItems() {
			return this.filteredContextTasks(this.items, this.excludedItems, this.withoutContextFilter);
			//return this.tasks.items;
			// /return this.items?.slice(0,100);
		},
		/** Set id выбранных задач - передаётся вниз в context-task, чтобы isSelected был O(1) на строку. */
		selectedTaskIdSet() {
			return new Set((this.selectedTasks || []).map(el => el.id));
		},
		componentClass() {
			const c = [];
			if (!this.parent) c.push("--root");
			if (!this.sortedTasks?.length) c.push("--empty");
			if (this.ui.withTaskDropZones) c.push("--drop-zones");
			return c.length ? c : null;
		},
		/**
		 * Группа, в которой находится список: сам context.item, если это группа, иначе корневая группа
		 * из цепочки context.parents. Нужна для списка исполнителей нового задачи-черновика.
		 */
		groupOfContext() {
			if (this.context.item?.isGroup) return this.context.item;
			if (this.context.parents?.length) return this.context.parents.find(el => el.isGroup) || null;
			return null;
		},
		withDND() {
			//sreturn false; // TODO implement DND

			if (!this.isMD) return false;
			if (this.isHistoryMode) return false;
			if (this.isListMode) return false;
			if (this.context.item?.isPick) return false;
			if (!this.context.item?.withFullAccess) return false;
			// пока backend выполняет swap цели, список не двигаем
			if (this.ui.pendingGoalSwap) return false;
			return !this.readonly;
			/*const context = this.context.item;
			if ( !context ) return false;
			const sortType = sortTypes.find(el => el.id === context.sortType);
			return sortType?.isSortable && this.withTree;*/
		},
		hasActorOfGroupTaskSort: {
			get() {
				return !!this.actorOfGroupTaskSort;
			},
			set(v) {
				return;
			}
		},
		actorOfGroupTaskSort() {
			const userAuth = this.$store.state.ui.mutations.groupTaskSort.userAuth;
			return this.usersById.get(userAuth);
			//console.log("MS", ms);
			//const hasGroupOrTopicMutations = ms.find(el=>el);
			/*return this.$store.state.lastMutations === "group/taskSort"
			|| this.$store.state.lastMutations === "topic/taskSort";*/
		},
		actorOfGroupTaskSortNick() {
			return nick(this.actorOfGroupTaskSort);
		},
		/*tab() {
			return this.page.tasks.tab;
		},*/
		parentPos() {
			if (this.parent) return this.parent.pos;
			return "";
		},
		canHaveChildren() {
			// todo limit level
			return this.withNewTask;
		},
		withTree() {
			return this.forceTree
				|| (this.context.mode === MODES.TREE && !!(this.context.item?.isGroup || this.context.item?.isTask));
		},
		isHistoryMode() {
			return this.listMode.mode === MODES.HISTORY;
		},
		isListMode() {
			return this.listMode.mode === MODES.LIST;
		},
		emptyStub() {
			if (this.context.item?.preset === PRESETS.SEARCH) return "такие задачи не найдены";
			return "пусто";
		},
		emptyStyle() {
			const s = {
				"padding-left": this.isMD ? (85 + 32 * (this.level-1)) + "px" : "0",
				//"text-align": this.isMD ? "left"
			};
			return s;
		},
	},
	watch: {
		"parent.id"(val) {
			// смена родителя из-за swap цели сохраняет ключи строк, любая другая - сбрасывает
			const swap = this.swapKeyScope;
			this.keyScope = swap && swap.to === val ? swap.from : null;
			this.swapKeyScope = null;
		},
		group: {
			immediate: true,
			handler(val, old) {
				if (val?.auth !== old?.auth) this.scrollToSelectedTask();
			}
		},
		topic: {
			immediate: true,
			handler(val, old) {
				if (val?.auth !== old?.auth) this.scrollToSelectedTask();
			}
		},
		items: {
			immediate: true,
			handler() {
				this.updateSubtitles();
			}
		},
		"listMode.mode": {
			handler() {
				this.updateSubtitles();
			}
		},

		/*"task.item": {
			immediate: true,
			handler(val, old) {
				if (old) {
					//TODO move this to state? clear this on uiClearBeforeRouting?
					this.removeFromSelectedTasks(old);
				}
				if (val) {
					// important to use context tree task, not the editor task
					const ct = this.tasks.flatItems?.find(el=>el.id===val.id);
					if ( ct ) this.appendSelectedTasks(ct, false, true);
				}
			}
		},*/
	},
	methods: {
		/**
		 * Расставляет заголовки-разделители по датам (item._subtitle) в history-режиме.
		 * Вынесено из computed sortedTasks в watcher, т.к. Vue.set - это побочный эффект,
		 * а не чтение, и не должен жить внутри computed-геттера.
		 */
		updateSubtitles() {
			let lastDate;
			const subtitleProp = this.listMode.prop;
			const subtitleProp2 = this.listMode.prop2;
			if (!subtitleProp) return;
			this.items?.forEach(el => {
				const value = el[subtitleProp] || el[subtitleProp2];
				const d = mysql2DDMMYYYY(value);
				if (!lastDate || d !== lastDate) {
					lastDate = d;
					Vue.set(el, "_subtitle", lastDate);
				} else Vue.set(el, "_subtitle", null);
			});
		},
		onMouseDownBackground() {
			//console.log("onClickBackground");
			if (!this.readonly) this.commit("contextClearSelectedTasks");
		},
		onDragStart(payload) {
			console.log("onDragStart", payload);
			this.commit("uiSetWithTaskDropZones", true);
		},
		onDragEnd(payload) {
			this.commit("uiSetWithTaskDropZones", false);
		},
		/** Начало перетаскивания цели процесса: списки показывают drop-зоны только там, где цель можно бросить. */
		onGoalDragStart(payload) {
			this.commit("uiSetDraggedGoal", {id: this.goalTask?.id, contextId: this.goalTask?.contextId});
			this.onDragStart(payload);
		},
		onGoalDragEnd(payload) {
			this.commit("uiSetDraggedGoal", null);
			this.onDragEnd(payload);
		},
		/**
		 * Индекс (context_task.index) для сброса перед задачей destination.item либо в конец списка ("last").
		 * @returns {number|null} null - целевая задача не найдена
		 */
		dropIndexFor(destination) {
			if (destination.item === "last" || destination.item === "after-goal") {
				// last index + 1
				return this.sortedTasks?.length ? this.sortedTasks[this.sortedTasks.length-1].index+Config.CONTEXT_INDEX_STEP : 0;
			}
			// obtain index of an item where we want to be placed
			const arrayIndexOfRight = this.sortedTasks?.findIndex(el => el.id === destination.item);
			if (arrayIndexOfRight === -1) return null;
			const right = this.sortedTasks[arrayIndexOfRight];
			const arrayIndexOfLeft = arrayIndexOfRight-1;
			// index should become first
			if (arrayIndexOfLeft < 0) return right.index - Config.CONTEXT_INDEX_STEP;
			// index should become smth between itemAbove and itemBelow
			const left = this.sortedTasks[arrayIndexOfLeft];
			// no space left between above and below - take index of below
			if (right.index - left.index < 2) return right.index;
			return Math.floor((left.index + right.index)/2);
		},
		/**
		 * Сброс цели процесса среди его собственных шагов. Структуру меняет backend (последний назначаемый шаг
		 * становится новой целью, бывшая цель - шагом в этой позиции); до ответа показываем это оптимистично
		 * (мутация uiSetPendingGoalSwap до запроса), после ответа переходим в контекст новой цели.
		 * Возвращает управление сразу после оптимистичного показа - сам запрос выполняется дальше в фоне.
		 * @returns {boolean} false - целевая позиция не найдена
		 */
		startGoalSwap(goal, destination, stepId) {
			const index = this.dropIndexFor(destination);
			if (index === null) return false;
			this.commit("uiSetPendingGoalSwap", {processId: goal.id, index, stepId});
			this.finishGoalSwap(goal, index, stepId);
			return true;
		},
		/** @param stepId - шаг, который становится новой целью (по умолчанию backend берёт последний назначаемый) */
		async finishGoalSwap(goal, index, stepId) {
			const isPageContext = this.context.item?.id === goal.id;
			// у процесса, открытого как контекст страницы, contextId не проставлен - backend сам найдёт родителя
			const parents = this.context.parents;
			const fromContextId = goal.contextId || (isPageContext ? parents?.[parents.length - 1]?.id : undefined);
			try {
				const res = await swapProcessGoal(goal.id, fromContextId, index, stepId);
				// список переедет на нового родителя - ключи строк шагов оставляем прежними
				this.swapKeyScope = {from: this.keyScope || this.parent?.id, to: res.newProcessId};
				await this.routeToSwappedProcess(res.newProcessId, goal);
			} catch (err) {
				console.warn("swapProcessGoal error", err);
				this.commit("uiError", {message: err?.message || "Не удалось поменять цель процесса"});
			} finally {
				this.commit("uiSetPendingGoalSwap", null);
			}
		},
		/**
		 * Цепочка контекстов до новой цели: новая цель встаёт на место бывшей, поэтому цепочка бывшей цели
		 * с последним звеном, заменённым на неё. Если бывшая цель была контекстом страницы - берём цепочку
		 * из текущего маршрута, иначе строим по её родителю (как для маршрутов строк списка).
		 */
		contextChainOfSwappedProcess(processId, goal) {
			const sep = Config.CONTEXT_ID_CHAIN_SEP;
			if (this.context.item?.id === goal.id) {
				const route = this.$router.currentRoute;
				const ids = parseContextIdChain(route.params.contextId)?.ids || [];
				const parentIds = ids.length ? ids.slice(0, -1) : (this.context.parents || []).map(el => el.id);
				return [...parentIds, processId].join(sep);
			}
			return goal.parent ? contextIdChainFor({id: processId}, undefined, goal.parent) : processId;
		},
		/**
		 * Переходит в контекст новой цели процесса с сохранением цепочки текущего контекста. Если была открыта
		 * задача (панель context-task) - остаёмся на ней уже внутри нового контекста, иначе открываем просто контекст.
		 */
		async routeToSwappedProcess(processId, goal) {
			const route = this.$router.currentRoute;
			const contextId = this.contextChainOfSwappedProcess(processId, goal);
			const taskId = route.name === "context-task" ? route.params.taskId : null;
			const query = {...route.query};
			await this.$router.push(taskId
				? {name: "context-task", params: {contextId, taskId, skipContext: false}, query}
				: {name: "context", params: {contextId, skipContext: false}, query});
		},
		onDropOverPos(source, destination) {
			return new Promise(async (resolve, reject) => {
				console.log("onDropOverPos", source, destination);
				if (source.zone === "goal") {
					// цель процесса можно бросить только среди его шагов (swap) или в родительском списке (обычный перенос)
					const goal = source.item;
					if (this.parent?.id === goal.id) {
						// drop считается обработанным сразу после оптимистичного показа - не ждём backend
						return this.startGoalSwap(goal, destination) ? resolve() : reject();
					}
					if (this.parent?.id !== goal.contextId) return reject();
				}
				// шаг этого процесса, брошенный после цели, становится новой целью (бывшая уходит в конец шагов)
				if (source.zone === "tasks" && destination.item === "after-goal" && this.parent?.isProcess
					&& source.payload?.length === 1 && source.payload[0].contextId === this.parent.id) {
					return this.startGoalSwap(this.parent, destination, source.payload[0].id) ? resolve() : reject();
				}
				if (source.zone === "tasks" || source.zone === "goal") {
					// some tasks dropped _before_ this task (before its pos)
					if (!source.payload?.length) return reject();
					const tasksInPayload = source.payload;

					const index = this.dropIndexFor(destination);
					if (index === null) return reject();
					console.log("dropping to index", index);
					//return;

					/*setTimeout(() => {
						console.log("Received drop confirmation");
						reject();
					}, 1000);
					return;*/

					// "Без проекта" в дереве пользователя - не контекст: это задачи самого пользовательского контекста
					const isNoGroupParent = !!this.parent?.isNoGroup;
					const contextId = isNoGroupParent
						? (this.context.item?.contextId || this.context.item?.id)
						: (this.parent?.id
							|| ((this.context.item?.isGroup || this.context.item?.isTask || this.context.item?.isUser) ? this.context.item?.contextId : null));
					const fromContextIds = tasksInPayload.map(el => el.contextId);

					// в "Без проекта" можно только переставлять свои задачи - вытащить в него задачу из проекта нельзя
					if (isNoGroupParent && fromContextIds.some(id => id !== contextId)) return reject();

					// todo make mass move, make folders support
					await this.do('task/move', {
						// source task ids
						taskIds: tasksInPayload.map(el => el.id),
						// source contexts (in same order)
						fromContextIds,
						// target context
						contextId,
						// desired index
						index,
						// current filter to refetch context tasks
						//filter: this.context.item?.filter
					});

					// refetch context indexes
					/*await this.do("context/indexes", {
						contextIds: [...fromContextIds, contextId].filter(onlyUnique),
						filter: this.context.item?.filter
					}).catch(err => {
						console.warn("error", err);
					});*/

					resolve();

					/*
					const task = source.payload[0];//this.page.tasks.flatItems?.find(el => el.id === taskIds[0]);
					if (task) {
						//console.log("dragging task", task);
						//console.log("fromContextId", fromContextId);

						if (taskIds.length) {
							this.do('task/move', {
								taskIds,
								fromContextId: task.contextId,	// todo make mass move support, make folders support
								contextId: this.parent?.id || (this.context.item?.isGroup ? this.context.item?.contextId : null),//this.context.item?.contextId,
								//parentId: this.item.id,
								//beforeId: null,
								//beforeId: destination.payload,
								//index,
							});
						}
					}*/
				} else reject();

			});
		},
		onSelect(item) {
			//console.log("onSelect in ", this.parent?.title, item?.title);
			if (!this.readonly) {
				//this.commit("contextClearSelectedTasks");
				this.appendSelectedTasks(item, false, true);
			}
			this.$emit("select", item);
		},
		onSelectWithCtrl(item) {
			//console.log("onSelectWithCtrl", item);
			//if ( item.id === this.task.item?.id ) return;
			this.appendSelectedTasks(item, true);
		},
		onSelectWithShift(item) {
			console.log("onSelectWithShift", item);
			return;

			// TODO

			// we allow shift selection ONLY if last item is at the same parent
			const lastItem = this.selectedTasks[this.selectedTasks.length - 1];
			if (lastItem && posAreSiblings(item.pos, lastItem.pos)) {

				const startIndex = this.items.findIndex(el => el.id === lastItem.id);
				const stopIndex = this.items.findIndex(el => el.id === item.id);
				console.log("FIRST: " + this.items[startIndex].title);
				console.log("LAST: " + this.items[stopIndex].title);

				if (startIndex >= 0 && stopIndex >= 0) {
					//this.resetMultiselectedItems();
					if (stopIndex > startIndex) {
						for (let i = startIndex; i <= stopIndex; i++) {
							let item = this.items[i];
							this.appendSelectedTasks(item, false);
						}
					} else if (stopIndex < startIndex) {
						for (let i = startIndex; i >= stopIndex; i--) {
							let item = this.items[i];
							this.appendSelectedTasks(item, false);
						}
					}
				}
			} else this.onSelectWithCtrl(item);
		},
		onNewInlineTask() {
			console.log("onNewInlineTask", this.newInlineTask);
			const name = this.newInlineTask?.trim();
			if (!name) return;

			this.newInlineTask = null;
			let assigneeAuth;
			if (this.context.item) {
				const root = obtainRootContext();
				if (root?.isUser) assigneeAuth = root.id;
			}
			this.do("task/create", {
				contextId: this.context.item?.contextId,
				assigneeAuth,
				params: {
					name,
					isTemplate: this.context.tab === TABS.TEMPLATES,
					isNote: this.context.tab === TABS.NOTES || this.context.item?.preset === PRESETS.NOTES,
				},
			}).then(res => {
				console.log("TASK CREATED", res);
				//this.newInlineTask = null;
				//params.taskId = this.page.task.item.auth;
				//this.$router.push({name, params, query});
			});
		},
		onEscape() {
			//console.log("onEscape");
			this.commit("contextClearSelectedTasks");
		},
		isItemSelected(item, index) {
			return !!this.selectedTasks.find(el => el.id === item.id);
		},
		scrollToSelectedTask() {
			// todo this bugs at mobile
			if (!this.isMD) return;
			if (this.task.item) {
				const index = this.sortedTasks?.findIndex(el => el.id === this.task.item.id);
				if (index >= 0) this.scrollToIndex(index);
			}
		},
		/**
		 * Скроллит к задаче по её абсолютному индексу в sortedTasks. Если список виртуализирован
		 * и задача вне текущего окна рендера, сначала подводим scrollTop по оценочным высотам
		 * (virtualRowOffsets), ждём перерисовки окна и только потом доскролливаем до реального элемента.
		 */
		scrollToIndex(index) {
			const auth = this.sortedTasks?.[index]?.auth;
			if (!auth) return;

			const jumpToElement = () => {
				setTimeout(() => {
					document.getElementById("task-" + auth)?.scrollIntoView();
				}, 300);
			};

			if (!this.isVirtualized || (index >= this.renderRange.start && index < this.renderRange.end)) {
				jumpToElement();
				return;
			}

			const offsets = this.virtualRowOffsets?.offsets;
			this.$el.scrollTop = offsets?.[index] || 0;
			this.scrollTop = this.$el.scrollTop;
			this.$nextTick(() => this.$nextTick(jumpToElement));
		},
		absoluteIndex(index) {
			return this.isVirtualized ? this.renderRange.start + index : index;
		},
		onScroll() {
			if (this._scrollRafId) return;
			this._scrollRafId = requestAnimationFrame(() => {
				this._scrollRafId = null;
				this.scrollTop = this.$el.scrollTop;
			});
		},
		ensureContainerResizeObserver() {
			if (this._containerResizeObserver || typeof ResizeObserver === "undefined") return;
			this._containerResizeObserver = new ResizeObserver(entries => {
				this.clientHeight = entries[0]?.contentRect?.height ?? this.$el.clientHeight;
			});
			this._containerResizeObserver.observe(this.$el);
		},
		ensureRowResizeObserver() {
			if (this._rowResizeObserver || typeof ResizeObserver === "undefined") return;
			this._rowResizeObserver = new ResizeObserver(entries => {
				entries.forEach(entry => {
					const id = this._observedRowEls.get(entry.target);
					if (typeof id === "undefined") return;
					const height = entry.contentRect.height;
					if (height > 0 && this.rowHeights[id] !== height) Vue.set(this.rowHeights, id, height);
				});
			});
		},
		/**
		 * Синхронизирует набор наблюдаемых ResizeObserver'ом DOM-строк с тем, что сейчас
		 * реально отрендерено (this.$refs.rowEl) - вызывается после каждого изменения окна рендера.
		 */
		syncRowObservations() {
			if (!this.isVirtualized) return;
			this.ensureRowResizeObserver();
			if (!this._rowResizeObserver) return;

			const rowEls = this.$refs.rowEl || [];
			const currentEls = new Set(rowEls);

			for (const el of this._observedRowEls.keys()) {
				if (!currentEls.has(el)) {
					this._rowResizeObserver.unobserve(el);
					this._observedRowEls.delete(el);
				}
			}
			rowEls.forEach(el => {
				if (this._observedRowEls.has(el)) return;
				const id = el.dataset.rowId;
				if (typeof id === "undefined") return;
				this._observedRowEls.set(el, id);
				this._rowResizeObserver.observe(el);
			});
		},
		/*resetSelectedTasks(item) {
			this.selectedTasks.splice(0, this.selectedTasks.length);
			if (item) this.selectedTasks.push(item);
		},*/
		rejectIdsFor(item, index) {
			// 1. reject this item
			const rejectIds = [];
			if (item) rejectIds.push(item.id);
			else if (this.parent) rejectIds.push(this.parent.id);
			// 2. reject prev item
			if (index) rejectIds.push(this.items[index - 1].id);
			// 3. reject all parents
			const findParent = (item) => {
				if (item?.parent?.id) {
					rejectIds.push(item.parent.id);
					findParent(item.parent);
				}
			}
			findParent(item || this.parent);

			/*const debugId= "tpjHXazFRJqIsDOT9s74WyFl";
			if ( item?.id === debugId ) {
				console.log("rejectIds recalculated for " + debugId);
			}*/
			return rejectIds;
		},
		keyFor(item) {
			const scope = this.keyScope || this.parent?.id;
			return (scope ? scope + ":" : "") + item.id;
		},
		checkIfSomeTaskShouldBeSelected() {
			if ( this.task.item?.id ) {
				const ct = this.items?.find(el => el.id === this.task.item?.id);
				if (ct) this.appendSelectedTasks(ct, false, true);
			}
		}
	},
	created() {
		// не реактивные служебные поля windowed-рендеринга (см. syncRowObservations/onScroll) -
		// хранятся напрямую на this, а не в data(), по тому же принципу, что и в context-progress.vue
		this._observedRowEls = new Map();
		this._rowResizeObserver = null;
		this._containerResizeObserver = null;
		this._scrollRafId = null;
	},
	mounted() {
		//console.log("CONTEXT TASKS mounted");
		//this.checkIfSomeTaskShouldBeSelected();

		// windowed-рендеринг актуален только для корневого (virtualizable) списка - не заводим
		// scroll-listener/ResizeObserver на каждом из вложенных context-tasks дерева папок
		if (!this.virtualizable) return;
		this.$el.addEventListener("scroll", this.onScroll, {passive: true});
		this.ensureContainerResizeObserver();
		this.clientHeight = this.$el.clientHeight;
		this.scrollTop = this.$el.scrollTop;
	},
	updated() {
		if (this.isVirtualized) this.$nextTick(() => this.syncRowObservations());
	},
	beforeDestroy() {
		if (!this.virtualizable) return;
		this.$el.removeEventListener("scroll", this.onScroll);
		if (this._scrollRafId) cancelAnimationFrame(this._scrollRafId);
		if (this._containerResizeObserver) this._containerResizeObserver.disconnect();
		if (this._rowResizeObserver) this._rowResizeObserver.disconnect();
	}
}
</script>

<style lang="scss">
.context-tasks {
	position: relative;
	z-index: 1;
	box-sizing: border-box;
	//height: 100%; //calc(100vh - 146px);
	//overflow: hidden;
	display: flex;
	flex-direction: column;
	//padding: .25rem 0 0.25rem 0; //.25em;
	background: white;

	@include up($md) {
		background: unset;
		//background: rgba(0,0,0,0.02);
	}

	&.--drop-zones {
		.context-tasks__droppable {
			pointer-events: all;
			/*&-zone {
				background: rgba(0, 0, 255, 0.05);
			}*/
		}
	}

	&.--empty {
		//padding-top: 1rem;
		//height: 6rem;
	}

	&__item {
		width: 100%;

		&:first-child {
			.context-tasks__subtitle {
				margin-top: 0.5rem;
			}
		}
	}

	&__spacer {
		width: 100%;
		flex-shrink: 0;
		pointer-events: none;
	}

	&__new-task {
		//text-align: center;
		height: 3.5em;
		padding: 0 2rem 0 18px;

		.v-text-field {
			.v-input__prepend-outer {
				margin-right: 16px;
			}

			.v-input__append-inner {
				margin-right: 21px;
			}
		}
	}

	.__empty {
		text-align: center;
		//margin-left: 1rem;
		//margin-right: 1rem;
		@include up($md) {
			//margin-left: 4.5rem;
			text-align: left;
		}
	}

	&__droppable {
		///opacity: 0;
		z-index: 2;
		pointer-events: none;
		position: relative;
		width: 100%;
		height: 0;
		@include transition();

		&-zone {
			z-index: 1;
			position: absolute;
			width: 100%;
			height: 20px;
			/*min-height: 10px;
			max-height: 20px;*/
			left: 0;
			top: 0;
			//background: rgba(0,0,255,0.05);
			transform: translateY(-50%);

			&.--over {
				//background: rgba(0,0,255,0.05);
				&:after {
					position: absolute;
					left: 0;
					top: 50%;
					width: 100%;
					height: 5px;
					transform: translateY(-50%);
					background: map-get($blue, "lighten-1");
				}
			}
		}
	}

	&__steps {
		&-toggle {
			padding: 0 0 0 82px;
			.v-btn {
				color: map-get($grey, "darken-1");
				justify-content: flex-start;
			}
		}
		&-current {
			display: flex;
			align-items: center;
			gap: $general-padding * 1.5;
			margin: 0 0 .75rem 0;
			padding: $min-padding 32px $min-padding 80px;
			//@include pad();
			background: white;

			&-title {
				flex: 1;
			}
		}
	}

	&__subtitle {
		margin: 1.5rem 0 0 .25rem;
		padding: 0.5rem 0 0 7rem;
		border-top: 1px solid map-get($grey, "lighten-2");
		height: 1.5rem;

		span {
			position: relative;
			top: -1.45rem;
			font-size: $font-size-5;
			background: map-get($grey, "lighten-4");
			padding: 0 0.5rem;
		}
	}

	.__debug {
		width: 100%;
		height: 10px;
		background: red;
	}

	.context-task {
		.draggable {
			z-index: 1;

			&.--over {
				&:after {
					border: 2px dotted map-get($blue, "lighten-1");
				}
			}
		}
	}
}
</style>
